import { Button } from '@heathmont/moon-components';
import { Caption, Heading } from '@heathmont/moon-core';
import { rem } from '@heathmont/moon-utils';
import Translate from '~/client/shared/i18n/Translate';
import StyledImg from '~/client/shared/images/styles/StyledImg';
import NextLink from '~/client/shared/NextLink';
import Stack from '~/client/shared/Stack';
import { CDN_IMG_URL } from '~/shared/cdn/url';

type Props = {
  name: string;
  handle: string;
  count: number;
  sendToGtm: (action?: string) => void;
};

const ProviderInfo: FC<Props> = ({ name, handle, count, sendToGtm }) => (
  <Stack space="large" padding={rem(16)}>
    <NextLink
      prefetch={false}
      href={`/providers/${handle}`}
      onClick={() => sendToGtm}
    >
      <>
        <StyledImg
          src={`${CDN_IMG_URL}/providers/${handle}.svg`}
          alt={name}
          height={56}
        />
        <Heading as="h4" size={20} color="trunks.100">
          {name}
        </Heading>
        <Caption color="trunks.100" as="span">
          <Translate id="casino.games_count" values={{ count }} />
        </Caption>
      </>
    </NextLink>
    <NextLink
      prefetch={false}
      href={`/providers/${handle}`}
      onClick={() => sendToGtm}
    >
      <Button variant="secondary">
        <Translate id="casino.see_all_games" />
      </Button>
    </NextLink>
  </Stack>
);

export default ProviderInfo;
